import { create } from 'zustand';

export interface AssignedTemplateStoreState {
  assignedTemplateOpen?: string;
  setAssignedTemplateOpen: (value?: string) => void;
}
export const useAssignedTemplateStore = create<AssignedTemplateStoreState>()((set) => ({
  assignedTemplateOpen: '',
  setAssignedTemplateOpen: (assignedTemplateOpen?: string) => set({ assignedTemplateOpen }),
}));
